module.exports = __webpack_public_path__ + "confetti-desktop___22Eb-.svg";